/**
 *
 * @param lang language locale attribute
 * @returns true|false validator status
 */
const isValidLanguageValidator: (lang: string) => boolean = (lang: string) =>
  [
    'en',
    'nl',
    'it',
    'fr',
    'hu',
    'cs',
    'pl',
    'ro',
    'es',
    'pt',
    'de',
    'sv',
    'fi',
    'none',
  ].includes(lang);

export default isValidLanguageValidator;
